module.exports = __webpack_public_path__ + "static/media/CatarinaDuarte.a0b91013.png";